// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"a10a3f92e9--breadcrumbs--nVAW3","link":"a10a3f92e9--link--fXWgV"};